import React, { Component } from "react";
import moment from "moment";
import styled from "styled-components";

const Container = styled.div`
  box-shadow: 0 3px 7px -3px rgba(0, 0, 0, 0.3);
  color: #fff;
  position: relative;
  float: left;
  overflow: hidden;
  margin-top: 10px;
  margin-left: 5px;
  margin-right: 5px;
  margin-bottom: 10px;
  max-width: ${props => `${props.containerWidth}px`};
  min-height: ${props => `${props.containerHeight}px`};
  width: 100%;
  background-color: #ffffff;
  color: #000000;
  text-align: left;
  font-size: 16px;
  &:* {
    box-sizing: border-box;
    transition: all 0.25s ease;
  }
`;
const Wrapper = styled.div`
  padding-left: 25px;
  padding-right: 25px;
  position: relative;
`;
const Date = styled.div`
  background-color: ${props => props.primaryColor};
  top: 25px;
  color: #fff;
  left: 25px;
  min-height: 60px;
  min-width: 60px;
  position: absolute;
  text-align: center;
  transition-delay: 0.2s;
  font-size: 22px;
  font-weight: 700;
  text-transform: uppercase;
`;
const Day = styled.span`
  display: block;
  line-height: 30px;
`;
const Month = styled.span`
  display: block;
  line-height: 30px;
  font-size: 16px;
  background-color: rgba(0, 0, 0, 0.1);
`;

const Image = styled.img`
  width: 100%;
  vertical-align: top;
  transform-origin: 50% 100%;
  transition: all 0.4s ease;
`;
const Title = styled.h4`
  margin-top: 10px !important;
  margin-bottom: 10px !important;
  display: inline-block !important;
  font-weight: 600 !important;
  color: #333333 !important;
  text-align: center !important;
`;
const Summary = styled.p`
  font-family: "Open Sans" !important;
  font-size: 13px !important;
  text-align: justify !important;
  margin-bottom: 10px !important;
  line-height: 1.6em !important;
`;

export class NewsWhiteCard extends Component {
  render() {
    const { news, newsNumber, primaryColor, containerHeight, containerWidth } = this.props;
    if (news.length === 0) return null;
    return news.items.slice(0, newsNumber).map((article, i) => (
      <Container key={i} containerHeight={containerHeight} containerWidth={containerWidth}>
        {article.image && <Image src={article.image.split("|")[0]} alt="" />}
        <Date primaryColor={primaryColor}>
          <Day>
            {moment(article.created)
              .locale("fr")
              .date()}
          </Day>
          <Month>
            {moment(article.created)
              .locale("fr")
              .format("MMM")}
          </Month>
        </Date>
        <Wrapper>
          <Title>{article.title}</Title>
          <Summary><div dangerouslySetInnerHTML={{__html: article.description}}></div></Summary>
        </Wrapper>
      </Container>
    ));
  }
}



// WEBPACK FOOTER //
// ./src/components/News/NewsWhiteCard/index.js